<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Remote Control for {{pmsConnDetails.usr}}</v-card-title>
          <v-card-subtitle>{{pmsConnDetails.pmsType}}</v-card-subtitle>

          <v-row align="baseline" justify="center">
            <v-col>
              <v-select
                v-model="remoteControlCommand"
                :items="remoteControlCommands"
                label="Command"
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-btn
                :disabled="!remoteControlCommand"
                @click="remoteControl(remoteControlCommand)"
                color="success"
                class="ma-3"
                :loading="remoteControlPending"
              >Execute</v-btn>
            </v-col>
          </v-row>
          <v-row
            align="center"
            justify="center"
            v-if="remoteControlCommand == 'GetProperty' ||  remoteControlCommand == 'SetProperty'"
          >
            <v-col>
              <v-combobox
                :disabled="remoteControlCommand != 'GetProperty' &&  remoteControlCommand != 'SetProperty'"
                v-model="remoteControlPropertyName"
                :items="remoteControlPropertyNames"
              ></v-combobox>
            </v-col>
            <v-col>
              <v-text-field
                v-if="remoteControlCommand == 'SetProperty'"
                :disabled="remoteControlCommand != 'SetProperty'"
                v-model="remoteControlPropertyValue"
                label="Property Value"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="stretch" justify="center">
              <v-col>
                <json-viewer
                  :expand-depth="5"
                  copyable
                  boxed
                  sort
                  :value="remoteControlResults"
                  v-if="Object.entries(remoteControlResults).length"
                ></json-viewer>
                <p v-if="remoteControlMessage">Message: {{remoteControlMessage}}</p>
                <p v-if="remoteControlErrorMessage">Error: {{remoteControlErrorMessage}}</p>
              </v-col>
            </v-row>
            <v-row v-if="showLogFiles" class="mt-4">
            <v-col cols="12">
              <h3 class="text-subtitle-1 font-weight-bold">📁 Log Files</h3>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>Filename</th>
                    <th>Size (KB)</th>
                    <th>Date</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="file in logFiles" :key="file.key">
                    <td>{{ file.filename }}</td>
                    <td>{{ (file.size / 1024).toFixed(1) }}</td>
                    <td>{{ new Date(file.date).toLocaleString() }}</td>
                    <td>
                      <v-btn small color="primary" @click="downloadLogFile(file)">
                        Download
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";
import * as subscriptions from "@/graphql/subscriptions";

import wsproperties from "@/assets/wsproperties.json";

export default {
  props: {
    pmsConnDetails: Object,
  },
  data: function () {
    return {
      sub: "",
      remoteControlPending: false,
      remoteControlResults: {},
      remoteControlMessage: "",
      remoteControlErrorMessage: "",
      remoteControlPropertyName: "",
      remoteControlPropertyValue: "",
      remoteControlPropertyNames: [],
      remoteControlCommand: "list",
      remoteControlCommands: [
        { text: "Get Process Details", value: "list" },
        { text: "Get Appointment Book Details" },
        {
          text: "Get Auto Sync Status",
          value: "Get automatic synchronisation status",
        },
        { text: "Read Config Property", value: "GetProperty" },
        { text: "Write Config Property", value: "SetProperty" },
        { text: "Restart Sync", value: "Restart" },
        { text: "Remote Update Sync", value: "Auto Update" },
        { text: "Fetch Log Files", value: "FetchLogFiles" },
      ],
      showLogFiles: false,
      logFiles: [],
    };
  },
  created: async function () {
    this.sub = this.$route.params.sub;
    this.remoteControlPropertyNames = wsproperties.items;
  },
  methods: {
async remoteControl(taskType) {
  console.log("remoteControl", taskType);
  this.showLogFiles = false;
  this.remoteControlResults = {};
  this.remoteControlErrorMessage = "";
  this.remoteControlMessage = "";
  this.remoteControlPending = true;

  try {
    // Creating a subscription First
    let subscription;
    const subscribeToTask = (taskId) => {
      subscription = API.graphql(
        graphqlOperation(subscriptions.onPublishTaskResult, { taskId })
      ).subscribe({
        next: (result) => {
          console.log("onPublishTaskResult", result);

          const payload = result?.value?.data?.onPublishTaskResult;
          if (!payload) {
            console.warn("Empty payload");
            return;
          }

          const msg = payload.message ?? "";
          const err = payload.errorMessage ?? "";
          let resultObj = payload.result ?? {};

          if (typeof resultObj === "string" && resultObj.trim() !== "") {
            try {
              resultObj = JSON.parse(resultObj);
            } catch (e) {
              console.warn("Result is not valid JSON, keeping raw:", resultObj);
            }
          }

          if (taskType === "FetchLogFiles" && resultObj && Array.isArray(resultObj.files)) {
            this.logFiles = resultObj.files;
            this.showLogFiles = true;
            this.remoteControlResults = {};
          } else if (resultObj && Object.keys(resultObj).length > 0) {
            this.remoteControlResults = resultObj;
          }

          this.remoteControlMessage = msg;
          this.remoteControlErrorMessage = err;
          this.remoteControlPending = false;

          if (err || msg.toLowerCase().includes("completed") || taskType === "FetchLogFiles") {
            subscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error("Subscription error:", error);
          this.remoteControlErrorMessage = "Subscription failed";
          this.remoteControlPending = false;
        },
        complete: () => {
          console.log("Subscription completed");
          this.remoteControlPending = false;
        }
      });
    };

    // Sending the mutation After subscription is ready
    const taskRequest = await API.graphql(
      graphqlOperation(mutations.publishTaskRequest, {
        sub: this.sub,
        command: "TaskRequest",
        taskType: `RemoteControl_${taskType}`,
        parameters:
          taskType.indexOf("Property") >= 0
            ? JSON.stringify({
                propertyName: this.remoteControlPropertyName,
                propertyValue: this.remoteControlPropertyValue,
              })
            : "{}",
      })
    );

    console.log("task request response", taskRequest);

    const taskId = taskRequest?.data?.publishTaskRequest?.taskId ?? "";
    if (!taskId) {
      throw new Error("No taskId returned from publishTaskRequest");
    }

    this.remoteControlMessage = `Waiting on task ID ${taskId}`;
    subscribeToTask(taskId);

  } catch (err) {
    console.error("remoteControl error:", err);
    this.remoteControlErrorMessage = "Failed to start remote control task.";
    this.remoteControlPending = false;
  }
}
,
    async downloadLogFile(file) {
      try {
        const response = await fetch(file.url);

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Download failed:", response.status, errorText);
          alert("Failed to download file.");
          return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = file.filename;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading file:", error);
        alert("Could not download file.");
      }
    },
  },
};
</script>

